import React from "react";
import Field from "components/Field";

import { useStateSelector } from "utils/field";
import { getMemberOrgIds, getOrgName } from "utils/organization/membership";
import { getOrgIdFromCodeRef } from "utils/codes/refs";

import Checkbox from "components/Input/Checkbox";
import Select from "components/Input/Select";

// "Add to code library" and the library it means, as one control. The drawers lay their fields out
// on a fixed grid, so these two share one cell instead of taking a cell each and breaking the row.
const CodeLibraryDestination = ({ drawerAccessor, editingCodeRef = "", isLibCode = false, compact = false }) => {
    const organization = useStateSelector("organization");
    const { addToLibrary = false } = useStateSelector(drawerAccessor) || {};
    const orgIds = getMemberOrgIds(organization);

    // Editing a code that already belongs to an organization defaults to that organization, so a
    // change to a shared code does not quietly become a personal copy.
    const editingOrgId = getOrgIdFromCodeRef(editingCodeRef);

    return (
        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", whiteSpace: "nowrap" }}>
            <Field
                component={Checkbox}
                name={`${drawerAccessor}.addToLibrary`}
                label={isLibCode ? "Update code in library" : "Add to code library"}
                large
                disabled={isLibCode}
                type="checkbox"
                {...(compact ? { compact: true } : {})}
            />
            {orgIds.length > 0 && (
                <div style={{ minWidth: "12rem", flexShrink: 0 }}>
                    <Field
                        component={Select}
                        name={`${drawerAccessor}.orgLibraryId`}
                        //no label, and no header row either: both leave an empty box above the control
                        placeholder="My Library"
                        hideFieldHeader
                        options={[
                            { label: "My Library", value: "" },
                            ...orgIds.map((id) => ({ label: getOrgName(organization, id), value: id })),
                        ]}
                        setValue={editingOrgId || undefined}
                        //there is nowhere to save to until the code is going into a library at all
                        disabled={!addToLibrary}
                        compact
                    />
                </div>
            )}
        </div>
    );
};

export default CodeLibraryDestination;
